// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ImageIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ImageIcon" ref={forwardedRef} {...props}>
      <path d="M4 3h4v1.5H4.5v4.276l4.526-2.675L16.996 12H17v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m11.5 9.757L8.933 7.9 4.5 10.519V15.5h11z" />
      <path d="M16 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ImageIcon = /* @__PURE__ */ Object.assign(ImageIconComponent, {
  displayName: 'ImageIcon',
});
